import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="navbar">
      <div className="logo">CFJEXPERT</div>

      {/* Hamburger icon */}
      <div className="hamburger" onClick={toggleMenu}>
        <div className={`bar ${isOpen ? "open" : ""}`}></div>
        <div className={`bar ${isOpen ? "open" : ""}`}></div>
        <div className={`bar ${isOpen ? "open" : ""}`}></div>
      </div>

      <ul className={`nav-links ${isOpen ? "active" : ""}`}>
        <li>
          <Link to="/">Accueil</Link>
        </li>
        <li>
          <Link to="/services">A Propos de CFJEXPERT</Link>
        </li>
        <li>
          <Link to="/apropos">Nos Services</Link>

        </li>
        <li>
          <Link to="/packs">Nos Packs</Link>
        </li>
                
        <li>
          <Link to="/actualites">Actualités</Link>
        </li>
        <li>
          <Link to="/contact">Contact</Link>
        </li>

       <Link to="/contact#consultation">
  <button className="btn-devis">Demander une Consultation</button>
</Link>

      </ul>
    </nav>
  );
}

export default Navbar;
